import type { Track } from '@aera/schema';
import { useEffect } from 'react';

/**
 * Each track has its own tokens (tokens.css: .lp-root[data-track="overseas"]). The attribute goes on
 * <body>, which carries lp-root, so sheets and anything outside the page container follow the theme too.
 */
export function useTrackTheme(track: Track | null | undefined): void {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const body = document.body;
    if (track) body.dataset.track = track;
    else delete body.dataset.track;
    return () => {
      delete body.dataset.track;
    };
  }, [track]);
}
